<template>
    <div>
        <!-- Status -->
        <noncustom-prop v-if="object.custom_type"
            :object='object'
            :property='{label: object.custom_type.label, column: "custom_type"}'>
        </noncustom-prop>

        <!-- Start Date -->
        <div class='row' v-if='object.start_dte'>
            <div class='col-md-3'><strong>{{object.start_dte.label}}</strong></div>
            <div class='col-md-9'>{{formatDate(object, 'start_dte', 'MMM D, YYYY')}}</div>
        </div>

        <!-- End Date -->
        <div class='row' v-if='object.end_dte'>
            <div class='col-md-3'><strong>{{object.end_dte.label}}</strong></div>
            <div class='col-md-9'>{{formatDate(object, 'end_dte', 'MMM D, YYYY')}}</div>
        </div>
    </div>
</template>

<script>
    import ManageProperties from './../../mixins/manageProperties.js'
    import RelatedVue from './../details/parts/related.vue'
    import NoncustomVue from './parts/noncustom.vue'

    export default {
        props: ['object'],
        mixins: [ManageProperties],
        components: {
            'related': RelatedVue,
            'noncustom-prop': NoncustomVue,
        }
    };
</script>

